const rtrim = /^[/]+|[/]+$/g;

export const joinPaths = (...urls: string[]) => {
  return urls
    .map((url) => url.replace(rtrim, '').split('/'))
    .reduce((previousValue, currentValue) => previousValue.concat(currentValue), [])
    .join('/');
};
